function UserIcon({ ...rest }) {
  return (
    <svg width='20' height='22' viewBox='0 0 20 22' fill='none' {...rest}>
      <path
        d='M17.892 20V18C17.892 16.9391 17.4702 15.9217 16.7196 15.1716C15.9689 14.4214 14.9508 14 13.8892 14H5.88364C4.82203 14 3.80391 14.4214 3.05325 15.1716C2.30258 15.9217 1.88086 16.9391 1.88086 18V20'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.88657 10C12.0972 10 13.8893 8.20914 13.8893 6C13.8893 3.79086 12.0972 2 9.88657 2C7.67589 2 5.88379 3.79086 5.88379 6C5.88379 8.20914 7.67589 10 9.88657 10Z'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default UserIcon;
